export default "__VITE_ASSET__CbhXgyh9__"